import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_BOOK_APPOINTMENT_USER } from "../../../../../queries/v3/queries/get-user.js";
const useUser = () => {
  const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_USER);
  const userQuery = React.useCallback(
    (token) => query({
      context: {
        forwardHeaders: {
          Authorization: `Bearer ${token}`
        }
      }
    }),
    [query]
  );
  const data = React.useMemo(() => queryState.data?.me ?? void 0, [queryState.data]);
  return React.useMemo(
    () => [userQuery, { ...queryState, data }],
    [userQuery, queryState, data]
  );
};
export {
  useUser as default,
  useUser
};
//# sourceMappingURL=use-user.js.map
